export const COMPANY_NAME = "AKIFU ONLINE"
export const COMPANY_NAME_FULL = "AKIFU ONLINE"
export const BACKEND_ADDRESS = process.env.REACT_APP_BACKEND_ADDRESS
export const META_TITLE = "AKIFU ONLINE"
export const META_DESCRIPTION = "Welcome to AKIFU ONLINE"
export const META_IMAGE = "%PUBLIC_URL%/presentation.png"
export const META_URL = "https://ibanking.akifu.org"
export const ENABLE_OTHER_DEPOSIT = false
